// types
import { ReportColumnDto } from 'src/api';
// @mui
import { isAutogeneratedRow } from '@mui/x-data-grid-premium';
// luxon
import { DateTime } from 'luxon';
// constants
import { dateTimeAggregationModels } from '../constants/aggregation-model/date-time';

export function OrderDateColumn(index: number) {
  const column = {
    field: 'orderDate',
    headerName: 'Order date',
    description: 'Order date column',
    type: 'date',
    index,
    width: 200,
    groupable: true,
    availableAggregationFunctions: dateTimeAggregationModels,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params: any) => {
      if (!params.value) {
        return null;
      }
      if (isAutogeneratedRow(params.row)) {
        if (params.value instanceof DateTime) {
          return params.value.toLocaleString();
        }
        if (params.value instanceof Date) {
          return DateTime.fromJSDate(params.value).toLocaleString();
        }
      }
      return DateTime.fromJSDate(params.value).toLocaleString();
    },
  } as ReportColumnDto<any, any, any>;
  return column;
}
